import React, { useEffect, useRef, useState } from 'react'
import { ErrorModal } from '../../components/Modal'
import { useLocation, useParams } from 'react-router-dom'
import Button from '../../components/Button'
import Layout from '../../components/Layout'
import DownloadStyle from './DownloadStyle'
import { Spin } from 'antd'
import logo from '../../assets/images/logo-2.png'
import html2PDF from 'html2pdf.js'
import { get } from 'lodash'
import api from '../../api'
import moment from 'moment'
import { useSelector } from 'react-redux'
import formatPhoneNumber from '../../helpers/PhoneWithSpaces'
import './print.css'
import { useTranslation } from 'react-i18next'

const DownloadRu = () => {
	const { getMe } = useSelector((state) => state.main)
	const { t } = useTranslation()

	const location = useLocation()
	const errorRef = useRef()

	const dataLocation = get(location, 'state.data', {})
	const isNoutbuk = get(location, 'state.isNotebook', '')
	const isTablet = get(location, 'state.isTablet', '')
	const isMobilePhone = get(location, 'state.isMobilePhone', '')
	const isTechnique = get(location, 'state.isTechnique', '')
	const hasFirstPayment = get(location, 'state.fistPay', '')

	const [userData, setuserData] = useState({})
	const [paymentDates, setPaymentDates] = useState([])
	const [item, setItem] = useState()
	const [dollar, setDollar] = useState()
	const [invoice, setInvoice] = useState()
	const [userFields, setUserFields] = useState([])
	const [whsData, setWhsData] = useState([])

	const [isLoading, setIsLoading] = useState(false)
	const [isLoadingItem, setIsLoadingItem] = useState(false)
	const [isLoadingWhs, setIsLoadingWhs] = useState(false)
	const [isLoadingUser, setIsLoadingUser] = useState(false)
	const [isLoadingPayment, setIsLoadingPayment] = useState(false)
	const [isLoadingInvoice, setIsLoadingInvoice] = useState(false)

	const telephoneNum = userData?.U_Telephone?.includes(',')
		? userData?.U_Telephone?.split(',')
		: userData?.U_Telephone

	const color =
		get(item, 'U_Color', '') !== null
			? userFields
					?.find((item) => item.Name === 'Color')
					?.ValidValuesMD.find(
						(value) => get(item, 'U_Color', '') === value.Value,
					)?.Description || ''
			: ''

	const debtAmount = invoice?.DocTotal - paymentDates[0]?.InsTotal
	const installmentMonth = paymentDates ? paymentDates.length - 1 : '________'
	console.log('paymentDates', paymentDates)

	const paymentDate = paymentDates
		? moment(paymentDates[1]?.DueDate).format('DD')
		: '________'
	console.log('paymentDate ==>', paymentDate)

	const sotuvKursi =
		new Intl.NumberFormat('fr-FR').format(paymentDates[0]?.InsTotal * dollar) +
		'  '

	const oylikTolov = paymentDates ? paymentDates[1]?.InsTotal : '________'
	const vznos = new Intl.NumberFormat('fr-FR').format(paymentDates[0]?.InsTotal)
	const docTotal =
		new Intl.NumberFormat('fr-FR').format(invoice?.DocTotal) + '  '
	const imei = invoice?.DocumentLines[0]?.SerialNumbers[0]?.InternalSerialNumber
		? invoice.DocumentLines[0].SerialNumbers[0].InternalSerialNumber
		: '_______________'

	const fullItemName = item
		? `${`${item?.ItemName} ${color ?? ''} ${item?.U_Memory ?? ''} modeldagi, `}`
		: '{_____________________________'

	const whsNum = (whsCode) => {
		switch (whsCode) {
			case '01':
				return '+998	71 200 00 00'
			case '02':
				return '+998	71 200 00 00'
			case '03':
				return '+998	71 200 00 00'
			case '04':
				return '+998	71 200 00 00'

			default:
				break
		}
	}

	useEffect(() => {
		getUser()
		getInformationOfItem()
		getInfoOFDevice()
		userFieldsFn()
		getWhs()
	}, [])

	useEffect(() => {
		getUSD(paymentDates)
	}, [paymentDates])

	const userFieldsFn = () => {
		api
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq 'OITM' ",
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}

	const formatPhoneNumber4 = (phoneNum) => {
		// Split the phoneNum by ',' and '"' and remove empty entries
		const parts = phoneNum.split(/[,]/).filter(Boolean)

		return parts.length > 4 ? parts.slice(0, 4).join(', ') : parts.join(', ')
	}

	const getInformationOfItem = () => {
		setIsLoading(true)
		api
			.get(
				`SQLQueries('getInstallments')/List?docEntry='${location.state.data.DocEntry}'`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=50',
					},
				},
			)
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				console.log('resData', resData)

				setPaymentDates(resData)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setIsLoading(false)
			})
		// setIsLoading(false)
	}

	const getUser = () => {
		setIsLoadingUser(true)
		api
			.get(
				`BusinessPartners('${get(
					dataLocation,
					'CardCode',
					0,
				)}')?$select=CardCode,CardName,U_Telephone,Address,Phone1,Phone2,U_Gender,U_PS,BPAddresses,Fax`,
			)
			.then((res) => {
				const resData = JSON.parse(res.data)
				setuserData(resData)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setIsLoadingUser(false)
			})
	}

	const getWhs = () => {
		setIsLoadingWhs(true)
		api
			.get(`Warehouses`)
			.then((res) => {
				const resData = JSON.parse(res.data).value
				setWhsData(resData)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setIsLoadingWhs(false)
			})
	}

	const getUSD = (paymentDates) => {
		setIsLoadingPayment(true)
		api
			.get(
				`SQLQueries('getUSDRate')/List?date='${get(
					paymentDates[0],
					'DueDate',
					'',
				)}'`,
			)
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				setDollar(get(resData, '[0].Rate', 0))
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setIsLoadingPayment(false)
			})
	}

	const download = () => {
		let element = document.getElementsByClassName('contract')[0]

		// Ensure full width for PDF
		element.style.width = '210mm' // A4 width in mm
		element.style.maxWidth = '100%'

		html2PDF(element, {
			margin: [5, 0, 5, 0], // top, left, bottom, right margins in mm
			filename: 'contract.pdf',
			image: { type: 'jpeg', quality: 0.98 },
			html2canvas: {
				scale: 2,
				logging: true,
				letterRendering: true,
				width: element.scrollWidth, // ensures full width is rendered
				windowWidth: element.scrollWidth,
			},
			jsPDF: {
				unit: 'mm',
				format: 'a4',
				orientation: 'portrait',
			},
			pagebreak: {
				before: ['.talon-section'], // Break before the warranty section
			},
		})
	}

	const getInfoOFDevice = () => {
		setIsLoadingInvoice(true)
		api
			.get(`Invoices(${location.state.data.DocEntry})`)
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'DocumentLines[0]', [])
				setInvoice(JSON.parse(res.data))

				getItems(get(resData, 'ItemCode', ''))
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setIsLoadingInvoice(false)
			})
	}

	const getItems = (code) => {
		setIsLoadingItem(true)
		api
			.get(`Items('${code}')`)
			.then((res) => {
				const resDate = JSON.parse(res.data)
				setItem(resDate)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setIsLoadingItem(false)
			})
	}

	return (
		<Layout>
			<DownloadStyle>
				<Spin
					spinning={
						isLoadingInvoice ||
						isLoadingItem ||
						isLoadingUser ||
						isLoadingWhs ||
						isLoadingPayment ||
						isLoading
					}
				>
					<div className="flex justify-end">
						<Button
							onClick={download}
							btnStyle={{ marginBottom: 10, width: 200 }}
						>
							Загрузить договор
						</Button>
					</div>
					<div className="contract shadow-md">
						<div className="no-break">
							<h2 className="text-center">
								<b>РАСПИСКА</b>
							</h2>

							{isMobilePhone && (
								<div className="contract-content">
									<p>
										<span className="ml-8">Я</span>{' '}
										<span className="font-bold">{userData.CardName}</span>{' '}
										приобрёл(а) у продавца Абитова Мурода Мансуровича телефон
										марки: <span className="font-bold">{fullItemName}</span>с
										кодом IMEI: <span className="font-bold">{imei}</span>, на
										условиях рассрочки. Общая стоимость телефона составляет{' '}
										<span className="font-bold">{docTotal}</span>
										долларов США, из которых{' '}
										<span className="font-bold">
											{hasFirstPayment ? vznos : 0}{' '}
										</span>
										долларов США я предварительно оплатил(а) в сумах по
										ПРОДАЖНОМУ КУРСУ в размере{' '}
										<span className="font-bold">
											{' '}
											{hasFirstPayment ? sotuvKursi : 0}
										</span>
										. Оставшуюся сумму в размере {'  '}
										<span className="font-bold">
											{hasFirstPayment
												? debtAmount
												: paymentDates.reduce(
														(sum, item) => sum + item.InsTotal,
														0,
													)}
										</span>{' '}
										долларов США я обязуюсь оплачивать в течение{' '}
										<span className="font-bold">
											{hasFirstPayment
												? installmentMonth
												: installmentMonth + 1}{' '}
											месяцев,
										</span>{' '}
										каждого месяца числа{' '}
										<span className="font-bold">{paymentDate}</span>, в размере{' '}
										<span className="font-bold">{oylikTolov}</span> долларов США
										в сумах по продажному курсу коммерческих банков, в указанное
										продавцом место и без задержек. __________(подпись)
									</p>
									<p>
										<span className="ml-8">Если</span>я не смогу оплачивать
										ежемесячные платежи вовремя и в полном объеме, то обязуюсь
										вернуть телефон продавцу по первому его требованию в целости
										и сохранности, без каких-либо повреждений. Возврат телефона
										продавцу не означает полное погашение задолженности. На
										момент возврата телефона он будет оценен по его текущему
										состоянию и продан. Если даже после этого долг, указанный в
										расписке, не будет полностью покрыт, я обязуюсь погасить
										оставшуюся задолженность без промедления. Я был(а)
										предупреждён(а) и согласен(на), что даже при досрочной или
										просроченной оплате ежемесячных платежей, общая стоимость,
										согласованная в расписке, остается неизменной.
										____________(подпись)
									</p>
									<p>
										<span className="ml-8">Настоящим</span>я даю согласие на
										установку продавцом системы блокировки на устройство,
										которое я приобретаю в рассрочку. Я также согласен(на) на
										получение SMS-сообщений о ежемесячных платежах и
										задолженностях на устройство и указанные номера телефонов.
										Если я задержу ежемесячный платеж более чем на 5 рабочих
										дней или не оплачу его полностью, я согласен(на), чтобы
										продавец дистанционно заблокировал данное устройство. Если
										один покупатель приобрёл несколько устройств, и по одному
										или нескольким из них произойдёт задержка платежей, то
										уведомления будут отправлены по всем устройствам и они будут
										заблокированы дистанционно. Я был(а) предупреждён(а)
										продавцом и согласен(на), что при дистанционной блокировке
										устройства все данные в нём могут быть удалены.
										____________(подпись)
									</p>
									<p>
										<span className="ml-8">Я</span> даю своё согласие на
										обработку моих персональных данных, а также на списание
										суммы задолженности в случае долга или неуплаты с любых моих
										текущих и будущих платёжных карт (Uzcard/Humo и
										кобейдж-карт), найденных по моему идентификационному номеру.
										________(подпись).
									</p>
									<p>
										<span className="ml-8">Я</span> полностью ознакомился(лась)
										с гарантийным талоном устройства и согласен(на) на покупку
										на основании данных гарантийных условий.
										____________(подпись)
									</p>
									<p>
										<span className="ml-8">Коробка</span> устройства и документы
										будут храниться у продавца в качестве гарантии до полного
										погашения задолженности. После полного погашения долга по
										устройству, коробка и документы будут доставлены в магазин,
										где была совершена покупка, или в другой филиал по
										соглашению с покупателем, в течение 5 рабочих дней после
										последнего платежа. Если доставка в согласованный магазин не
										будет осуществлена в течение 5 рабочих дней, продавец обязан
										доставить коробку покупателю. Продавец обязуется хранить
										коробку в течение 1 месяца с даты полного погашения долга по
										технике, и не обязан хранить её дольше. Меня предупредили,
										что коробки от техники, не забранные вовремя, могут быть
										утилизированы. ____________(подпись)
									</p>
								</div>
							)}

							{isTablet && (
								<div className="contract-content">
									<p>
										<span className="ml-8">Я</span>{' '}
										<span className="font-bold">{userData.CardName}</span>{' '}
										приобрёл(а) у продавца Абитова Мурода Мансуровича планшет
										марки: <span className="font-bold">{fullItemName}</span>с
										кодом IMEI: <span className="font-bold">{imei}</span>, на
										условиях рассрочки. Общая стоимость планшета составляет{' '}
										<span className="font-bold">{docTotal}</span>
										долларов США, из которых{' '}
										<span className="font-bold">
											{hasFirstPayment ? vznos : 0}{' '}
										</span>
										долларов США я оплатил(а) заранее в сумах по ПРОДАЖНОМУ
										КУРСУ в размере{' '}
										<span className="font-bold">{sotuvKursi}</span>. Оставшуюся
										сумму в размере {'  '}
										<span className="font-bold">
											{hasFirstPayment
												? debtAmount
												: paymentDates.reduce(
														(sum, item) => sum + item.InsTotal,
														0,
													)}
										</span>{' '}
										долларов США я обязуюсь выплачивать в течение{' '}
										<span className="font-bold">
											{hasFirstPayment
												? installmentMonth
												: installmentMonth + 1}
											месяцев
										</span>{' '}
										ежемесячно, числа{' '}
										<span className="font-bold">{paymentDate}</span>, по{' '}
										<span className="font-bold">{oylikTolov}</span> долларов США
										в сумах по курсу продажи коммерческих банков, в указанное
										продавцом место, своевременно и без задержек.
										__________(подпись)
									</p>
									<p>
										<span className="ml-8">Если</span>я не смогу своевременно и
										в полном объеме оплачивать ежемесячные платежи, я обязуюсь
										вернуть планшет продавцу по первому его требованию в целости
										и сохранности, без каких-либо повреждений. Возврат планшета
										не означает полное погашение долга. При возврате планшет
										будет оценён по его состоянию и продан. Если после этого
										долг, указанный в расписке, не будет полностью погашен, я
										обязуюсь оплатить оставшуюся сумму без задержек. Я
										предупреждён(а) и согласен(на), что даже при досрочной или
										просроченной оплате сумма общей стоимости не изменится.
										__________(подпись)
									</p>
									<p>
										<span className="ml-8">Настоящим</span>я даю согласие на
										установку продавцом системы блокировки на устройство,
										приобретаемое мной в рассрочку. Я также согласен(на) на
										получение SMS-сообщений о ежемесячных платежах и
										задолженности на устройство и на указанные номера телефонов.
										Если я просрочу платеж более чем на 5 рабочих дней или не
										оплачу его полностью, я согласен(на), чтобы продавец
										дистанционно заблокировал устройство. Если один покупатель
										приобрёл несколько устройств, и по одному или нескольким из
										них будет задержка в оплате, то уведомления будут отправлены
										по всем устройствам и все они будут заблокированы
										дистанционно. Меня предупредили и я согласен(на), что при
										блокировке все данные на устройстве могут быть удалены.
										____________(подпись)
									</p>
									<p>
										<span className="ml-8">Я</span> даю согласие на обработку
										моих персональных данных, а также на списание задолженности
										с любых текущих и будущих платёжных карт (Uzcard/Humo и
										кобейдж-карт), обнаруженных по моему идентификационному
										номеру, в случае просрочки или неуплаты. __________(подпись)
									</p>
									<p>
										<span className="ml-8">Я</span> полностью ознакомился(лась)
										с гарантийным талоном устройства и согласен(на) на покупку в
										соответствии с условиями гарантии. ____________(подпись)
									</p>
									<p>
										<span className="ml-8">Коробка</span> и документы от
										устройства будут храниться у продавца в качестве гарантии до
										полного погашения задолженности. После полной оплаты долга,
										коробка и документы будут доставлены в магазин, где была
										совершена покупка, или в другой филиал по соглашению с
										покупателем, в течение 5 рабочих дней после последнего
										платежа. Если доставка в течение 5 рабочих дней не
										произведена, продавец обязан доставить коробку покупателю.
										Продавец обязуется хранить коробку в течение 1 месяца после
										полной оплаты и не обязан хранить её дольше. Меня
										предупредили, что коробки, не забранные вовремя, могут быть
										утилизированы. __________(подпись)
									</p>
								</div>
							)}

							{isNoutbuk && (
								<div className="contract-content">
									<p>
										<span className="ml-8">Я</span>{' '}
										<span className="font-bold">{userData.CardName}</span>{' '}
										приобрёл(а) у продавца Абитова Мурода Мансуровича устройство
										марки: <span className="font-bold">{fullItemName}</span>с
										серийным номером: <span className="font-bold">{imei}</span>,{' '}
										на условиях рассрочки. Общая стоимость устройства составляет{' '}
										<span className="font-bold">{docTotal}</span>
										долларов США, из которых{' '}
										<span className="font-bold">
											{hasFirstPayment ? vznos : 0}{' '}
										</span>
										долларов США я предварительно оплатил(а) в сумах по
										ПРОДАЖНОМУ КУРСУ в размере{' '}
										<span className="font-bold">{sotuvKursi}</span>. Оставшуюся
										сумму в размере{' '}
										<span className="font-bold">
											{hasFirstPayment
												? debtAmount
												: paymentDates.reduce(
														(sum, item) => sum + item.InsTotal,
														0,
													)}
										</span>{' '}
										долларов США я обязуюсь выплачивать в течение{' '}
										<span className="font-bold">
											{hasFirstPayment
												? installmentMonth
												: installmentMonth + 1}
											месяцев
										</span>{' '}
										ежемесячно, числа{' '}
										<span className="font-bold">{paymentDate}</span>, по{' '}
										<span className="font-bold">{oylikTolov}</span> долларов США
										в сумах по курсу продажи коммерческих банков в указанное
										продавцом место, своевременно и без задержек.
										__________(подпись)
									</p>
									<p>
										<span className="ml-8">Если</span>я не смогу своевременно и
										в полном объеме оплачивать ежемесячные платежи, я обязуюсь
										вернуть устройство продавцу по первому его требованию в
										целости и сохранности, без каких-либо повреждений. Возврат
										устройства не означает полное погашение задолженности. На
										момент возврата устройство будет оценено по его текущему
										состоянию и продано. Если после этого долг, указанный в
										расписке, не будет полностью погашен, я обязуюсь оплатить
										оставшуюся сумму без задержек. Я предупреждён(а) и
										согласен(на), что даже при досрочной или просроченной оплате
										сумма общей стоимости остаётся неизменной.
										____________(подпись)
									</p>
									<p>
										<span className="ml-8">Настоящим</span>я даю согласие на
										получение SMS-сообщений на указанные мною номера телефонов о
										ежемесячных платежах и задолженности. ____________(подпись)
									</p>
									<p>
										<span className="ml-8">Я</span> даю согласие на обработку
										моих персональных данных, а также на списание суммы долга с
										любых моих текущих и будущих платёжных карт (Uzcard/Humo и
										кобейдж-карт), обнаруженных по моему идентификационному
										номеру, в случае неуплаты или задержки.
										____________(подпись)
									</p>
									<p>
										<span className="ml-8">Я</span> полностью ознакомился(лась)
										с гарантийным талоном устройства и согласен(на) на покупку в
										соответствии с указанными гарантийными условиями.
										____________(подпись)
									</p>
									<p>
										<span className="ml-8">Коробка</span> и документы от
										устройства будут храниться у продавца в качестве гарантии до
										полного погашения долга. После полной оплаты долга коробка и
										документы будут переданы в магазин, где была совершена
										покупка, или в другой согласованный филиал в течение 5
										рабочих дней после последнего платежа. Если передача не
										произойдёт в течение 5 рабочих дней, продавец обязан
										доставить коробку покупателю. С даты полной оплаты
										задолженности коробка будет храниться 1 месяц. Если за этот
										период она не будет забрана, продавец освобождается от
										обязательства по хранению. ____________(подпись)
									</p>
								</div>
							)}

							{isTechnique && (
								<div className="contract-content">
									<p>
										<span className="ml-8">Я</span>{' '}
										<span className="font-bold">{userData.CardName}</span>{' '}
										приобрёл(а) у продавца Абитова Мурода Мансуровича{' '}
										<span className="font-bold">{fullItemName}</span>с кодом
										IMEI: <span className="font-bold">{imei}</span>, на условиях
										рассрочки. Общая стоимость техники составляет{' '}
										<span className="font-bold">{docTotal}</span>
										долларов США, из которых{' '}
										<span className="font-bold">
											{hasFirstPayment ? vznos : 0}{' '}
										</span>
										долларов США я предварительно оплатил(а) в сумах по
										ПРОДАЖНОМУ КУРСУ в размере{' '}
										<span className="font-bold">{sotuvKursi}</span>. Оставшуюся
										сумму в размере{' '}
										<span className="font-bold">
											{hasFirstPayment
												? debtAmount
												: paymentDates.reduce(
														(sum, item) => sum + item.InsTotal,
														0,
													)}
										</span>{' '}
										долларов США я обязуюсь выплачивать в течение{' '}
										<span className="font-bold">
											{hasFirstPayment
												? installmentMonth
												: installmentMonth + 1}{' '}
											месяцев
										</span>{' '}
										ежемесячно, числа{' '}
										<span className="font-bold">{paymentDate}</span>, в размере{' '}
										<span className="font-bold">{oylikTolov}</span> долларов США
										в сумах по продажному курсу коммерческих банков, в указанное
										продавцом место, своевременно и без задержек.
										__________(подпись)
									</p>
									<p>
										<span className="ml-8">Если</span>я не смогу своевременно и
										в полном объеме выплачивать ежемесячные платежи, обязуюсь
										вернуть технику продавцу по первому его требованию в целости
										и сохранности, без каких-либо повреждений. Возврат техники
										не означает полное погашение задолженности. На момент
										возврата техника будет оценена по её состоянию и продана.
										Если даже после этого задолженность, указанная в расписке,
										не будет погашена, обязуюсь оплатить оставшуюся сумму без
										задержек. Меня предупредили и я согласен(на), что даже при
										досрочной или просроченной оплате, общая стоимость,
										согласованная в расписке, остаётся неизменной.
										__________(подпись)
									</p>
									<p>
										<span className="ml-8">Настоящим</span>я даю согласие на
										установку продавцом системы блокировки на технику,
										приобретаемую мной в рассрочку (если установка возможна).
										Также я согласен(на) на получение SMS-сообщений о
										ежемесячных платежах и задолженности на устройство и
										указанные номера телефонов. Если я задержу платёж более чем
										на 5 рабочих дней или не оплачу его полностью, я
										согласен(на) на дистанционную блокировку устройства
										продавцом. Если покупатель приобрёл несколько технических
										товаров и по одному или нескольким возникнут просрочки, то
										уведомления будут отправлены по всем устройствам и они будут
										заблокированы. Меня предупредили и я согласен(на), что при
										дистанционной блокировке все данные на устройстве могут быть
										удалены. ____________(подпись)
									</p>
									<p>
										<span className="ml-8">Я</span> даю своё согласие на
										обработку моих персональных данных, а также на списание
										средств с любых текущих и будущих платёжных карт
										(Uzcard/Humo и кобейдж-карт), обнаруженных по моему
										идентификационному номеру, в случае неуплаты или
										задолженности. __________(подпись)
									</p>
									<p>
										<span className="ml-8">Я</span> полностью ознакомился(лась)
										с гарантийным талоном техники и согласен(на) приобрести её
										на условиях указанной гарантии. ____________(подпись)
									</p>
									<p>
										<span className="ml-8">Коробка</span> и документы на технику
										будут храниться у продавца в качестве гарантии до полного
										погашения задолженности. После этого коробка и документы
										будут переданы в магазин, где была совершена покупка, или в
										согласованный с покупателем филиал, в течение 5 рабочих дней
										после последнего платежа. Если в течение 5 рабочих дней
										доставка не будет осуществлена, продавец обязан доставить
										коробку покупателю. Продавец обязуется хранить коробку в
										течение 1 месяца с даты полной оплаты, после чего не обязан
										продолжать хранение. Меня предупредили, что не забранные
										вовремя коробки могут быть утилизированы.
										__________(подпись)
									</p>
								</div>
							)}

							<div>
								<h1 className="text-center mt-10 mb-3">
									<b>ПРИМЕЧАНИЕ</b>
								</h1>
								{isMobilePhone && (
									<div className="ml-8">
										<p>
											<b>1. </b>
											Покупатель обязан полностью проверить устройство до выхода
											из магазина. Если обнаружены какие-либо физические
											повреждения (например, трещины на экране или корпусе,
											пятна), об этом необходимо сообщить продавцу до выхода из
											магазина. Если устройство будет возвращено с подобными
											повреждениями после выхода, продавец ответственности не
											несёт.
										</p>
										<p>
											<b>2. </b>
											Продавец не обязан возвращать или обменивать телефон в
											случае, если он перестал нравиться покупателю после
											покупки. После подписания расписки сроки и цена не
											подлежат изменению.
										</p>
										<div>
											<p>
												<b>3. </b>
												Если телефон будет повреждён физически по вине
												покупателя, использован неправильно или отремонтирован
												неавторизованным специалистом (в этом случае гарантия
												недействительна), а также в случае утери или кражи,
												покупатель обязан продолжать оплачивать установленные в
												расписке суммы в срок и в полном объёме.
											</p>
										</div>
										<p>
											<b>4. </b>
											Если покупатель попытается взломать системы, установленные
											продавцом (например, iCloud, Samsung Account или MI
											Account), или изменит введённые данные, продавец
											освобождается от обязанности удалить эти аккаунты с
											телефона. В таком случае ответственность полностью ложится
											на покупателя.
										</p>
									</div>
								)}

								{isTablet && (
									<div className="ml-8">
										<p>
											<b>1. </b>
											Покупатель обязан полностью проверить устройство до выхода
											из магазина. Если есть какие-либо физические повреждения
											(например, трещины на экране или корпусе, пятна), об этом
											нужно сообщить продавцу до выхода из магазина. Если
											планшет возвращается с такими повреждениями после выхода,
											продавец ответственности не несёт.
										</p>
										<p>
											<b>2. </b>
											Продавец не обязан возвращать или обменивать планшет, если
											он не понравился покупателю после покупки. После
											подписания расписки сроки и цена не подлежат изменению.
										</p>
										<div className="mt-5">
											<p>
												<b>3. </b>
												Если планшет будет физически повреждён по вине
												покупателя, использован неправильно или отремонтирован
												неавторизованным мастером (в этом случае гарантия
												недействительна), а также в случае кражи или утери
												устройства, покупатель обязан оплачивать указанные в
												расписке платежи в срок и в полном объёме.
											</p>
										</div>
										<p>
											<b>4. </b>
											Если покупатель попытается взломать системы, установленные
											продавцом (например, iCloud, Samsung Account или MI
											Account), или изменит введённые данные, продавец
											освобождается от обязанности удалить данные системы с
											планшета. В таком случае ответственность полностью ложится
											на покупателя.
										</p>
										<p>
											<b>5. </b>Я соглашаюсь соблюдать все условия настоящей
											расписки даже в случае форс-мажора или карантина.
											Гарантирую, что такие обстоятельства не будут препятствием
											для своевременной оплаты ежемесячных платежей.
										</p>
									</div>
								)}

								{isNoutbuk && (
									<div className="ml-8">
										<p>
											<b>1. </b>
											Покупатель обязан полностью проверить устройство до его
											выноса из магазина. Если имеются физические повреждения
											экрана или корпуса, об этом необходимо сообщить продавцу
											до выхода из магазина. Продавец не несёт ответственности
											за повреждения, выявленные после выхода из магазина.
										</p>
										<p>
											<b>2. </b>
											После покупки устройства, если оно не понравится
											покупателю, продавец не обязан его возвращать или
											обменивать. После подписания расписки условия договора не
											подлежат изменению.
										</p>
										<div>
											<p>
												<b>3. </b>В случае физического повреждения устройства по
												вине покупателя, неправильного использования, обращения
												к неавторизованным специалистам, а также в случаях кражи
												или утери, покупатель обязан в полном объёме и в срок
												погасить всю задолженность.
											</p>
										</div>
										<p>
											<b>4. </b>
											Если покупатель самовольно установит на устройство пароли
											или блокировочные системы, и это вызовет какие-либо
											проблемы, продавец ответственности за это не несёт.
										</p>
										<p>
											<span className="ml-5">Я</span> соглашаюсь выполнить все
											условия этой расписки даже в случае форс-мажорных
											обстоятельств или карантина. Полностью гарантирую, что
											данные обстоятельства не помешают своевременной оплате
											ежемесячных платежей.
										</p>
									</div>
								)}

								{isTechnique && (
									<div className="ml-8">
										<p>
											<b>1.</b>
											Покупатель обязан полностью проверить технику до выхода из
											магазина. Если имеются физические повреждения (например,
											трещины на экране или корпусе, пятна), об этом необходимо
											сообщить продавцу до выхода. Если техника будет возвращена
											с такими повреждениями после выхода, продавец
											ответственности не несёт.
										</p>
										<p>
											<b>2.</b>
											Если техника не понравилась покупателю после покупки,
											продавец не обязан принимать её обратно или менять на
											другую. После подписания расписки сроки и цена не подлежат
											изменению.
										</p>
										<div>
											<p>
												<b>3.</b>
												Если техника будет повреждена по вине покупателя,
												использована неправильно, отремонтирована
												неавторизованным мастером (в этом случае гарантия
												недействительна), а также если она будет украдена или
												утеряна — покупатель всё равно обязан оплачивать в срок
												все платежи, указанные в расписке.
											</p>
										</div>
										<p>
											<span className="ml-5">Я</span> соглашаюсь выполнять все
											условия настоящей расписки даже в случае форс-мажора или
											карантина. Полностью гарантирую, что такие обстоятельства
											не будут препятствием для своевременной оплаты ежемесячных
											платежей.
										</p>
									</div>
								)}

								<div className="flex w-full mt-10 font-bold">
									<hr className="w-full border-t font-bold border-black" />
								</div>

								<div className="flex w-full mt-10 font-bold">
									<hr className="w-full border-t font-bold border-black" />
								</div>
							</div>

							<div className="ml-[5px] mt-10 flex items-center justify-between">
								<div className="flex flex-col gap-3">
									<p>
										<b>Номер телефона покупателя:</b>
									</p>
									<div>
										{Array.isArray(telephoneNum) ? (
											telephoneNum.slice(0, 4).map((num, index) => (
												<p key={index}>
													<b>
														{index + 1}.{' '}
														{formatPhoneNumber(formatPhoneNumber4(num))}
													</b>
												</p>
											))
										) : (
											<p>
												<b>1. {formatPhoneNumber(telephoneNum)}</b>
											</p>
										)}
									</div>
								</div>

								<div>
									<img src={logo} className="w-[200px]" alt="logo" />
								</div>

								<div className="flex flex-col gap-2">
									<p>
										<b>
											Дата:
											{paymentDates
												? moment(paymentDates[0]?.DocDate).format('DD.MM.YYYY')
												: '________'}
										</b>
									</p>

									<p>
										<b> Подпись: _____________</b>
									</p>
								</div>
							</div>
							<div className="flex flex-col gap-2">
								<p className="text-center font-extrabold text-base px-3">
									ГАРАНТИЙНЫЙ ТАЛОН
								</p>

								<p>
									<b>
										{isTechnique ? 'TEXNIKA' : 'QURILMA'} ТИП:{' '}
										{item?.U_Group
											? item?.U_Group
											: '__________________________________'}
									</b>
								</p>

								<p>
									<b>
										МОДЕЛЬ:{'    '}
										{item?.ItemName
											? item?.ItemName
											: '__________________________________'}
									</b>
								</p>
								<p>
									<b>
										{isTechnique ? 'TEXNIKA' : 'QURILMA'} СОСТОЯНИЕ:{'    '}
										{item?.U_Condition
											? item?.U_Condition
											: '__________________________________'}
									</b>
								</p>
								<p>
									<b>
										СЕРИННИЙ НОМЕР:{'    '}
										{invoice?.DocumentLines[0]?.SerialNumbers[0]
											?.InternalSerialNumber
											? invoice.DocumentLines[0].SerialNumbers[0]
													.InternalSerialNumber
											: '_______________'}
									</b>
								</p>
								<p>
									<b>
										ДАТА ПОКУПКИ:{'    '}
										{paymentDates
											? moment(paymentDates[0]?.DocDate).format('DD.MM.YYYY')
											: '________'}
									</b>
								</p>

								<p>
									<b>
										НОМЕР ТЕЛЕФОНА МАГАЗИНА:{'    '}
										{invoice?.DocumentLines[0]?.WarehouseCode
											? whsData?.find(
													(whs) =>
														whs.WarehouseCode ===
														invoice.DocumentLines[0].WarehouseCode,
												)?.U_Branch_Number
											: '_______________'}
									</b>
								</p>
								<div className="flex w-full flex-col px-6">
									<h1 className="text-center">
										<b>
											ГАРАНТИЙНЫЕ ОБЯЗАТЕЛЬСТВА И БЕСПЛАТНОЕ ОБСЛУЖИВАНИЕ
											УСЛОВИЯ
										</b>
									</h1>
									{isMobilePhone && (
										<p>
											<b>1.</b> Для осуществления гарантийного ремонта
											устройство должно быть приобретено в одном из магазинов
											CredoMobileUz. В качестве подтверждения этого необходимо
											предоставить коробку и документы от устройства, а также
											гарантийный талон, выданный при покупке в магазине.
											CredoMobileUz не предоставляет гарантию на устройства,
											купленные в других магазинах.
										</p>
									)}

									{isTablet && (
										<p>
											<b>1.</b> Для проведения гарантийного ремонта планшет
											должен быть куплен в одном из магазинов CredoMobileUz. В
											подтверждение необходимо предъявить коробку и документы от
											устройства, а также гарантийный талон, полученный при
											покупке. CredoMobileUz не предоставляет гарантию на
											технику, приобретённую в других магазинах.
										</p>
									)}

									{isNoutbuk && (
										<p>
											<b>1.</b> Для гарантийного ремонта ноутбук должен быть
											приобретён в одном из магазинов CredoMobileUz. Для
											подтверждения необходимо предоставить коробку и документы
											от устройства, а также гарантийный талон, полученный в
											момент покупки. На технику, приобретённую в других
											магазинах, гарантия от CredoMobileUz не распространяется.
										</p>
									)}

									{isTechnique && (
										<p>
											<b>1.</b> Для гарантийного ремонта техника должна быть
											приобретена в одном из магазинов CredoMobileUz. Необходимо
											предоставить коробку, документы на устройство и
											гарантийный талон, выданный при покупке. CredoMobileUz не
											несёт гарантийных обязательств по технике, приобретённой в
											других торговых точках.
										</p>
									)}
								</div>
							</div>

							<div className="talon-section bg-white px-6 relative">
								{/* First logo */}
								<img
									src={logo}
									alt="background logo"
									style={{
										position: 'absolute',
										top: '15%',
										left: '10%',
										width: '600px',
										height: '170px',
										transform: 'rotate(-380deg)',
										opacity: 0.5,
										zIndex: 0,
									}}
								/>

								{/* Second logo */}
								<img
									src={logo}
									alt="background logo"
									style={{
										position: 'absolute',
										top: '50%',
										left: '10%',
										width: '600px',
										height: '170px',
										transform: 'rotate(-380deg)',
										opacity: 0.5,
										zIndex: 0,
									}}
								/>

								{/* Add a semi-transparent overlay to make the watermark effect more subtle */}
								<div
									className="absolute inset-0"
									style={{
										zIndex: 1,
									}}
								></div>

								{/* Existing Content with higher z-index to stay above the overlay */}
								<div className="relative z-10">
									{isMobilePhone && (
										<div>
											<p>
												<b>2.</b> Устройство должно быть нераскрытым. Это легко
												проверить — на каждом устройстве есть пломбы,
												подтверждающие, что оно не вскрывалось.
											</p>
											<div>
												<p>
													<b>3.</b> Если у смартфона или другого устройства есть
													внешние повреждения, сервисное обслуживание не
													предоставляется. Например, если на углу экрана есть
													трещина или скол, то даже при неисправности другой
													части, например камеры, CredoMobile не предоставит
													гарантийное обслуживание. Причина в том, что
													повреждение экрана свидетельствует о падении или ударе
													устройства. Следовательно, камера могла быть
													повреждена при этом же инциденте, и производитель не
													несёт ответственности за такой случай.
												</p>
											</div>
											<p>
												<b>4.</b> В устройство не должно быть внесено
												нелегальных изменений в программное обеспечение.
												Например, если был получен root-доступ, производитель
												имеет право отказать в сервисном обслуживании. Такие
												модификации могут вывести из строя части устройства или
												операционную систему, и за такие случаи CredoMobile
												ответственности не несёт. Также гарантия не
												предоставляется на устройства с установленными
												бета-версиями операционных систем.
											</p>
											<p>
												<b>5.</b> В случае выявления заводского дефекта (без
												вмешательства покупателя) в течение 3 дней с момента
												покупки, устройство заменяется на аналогичное. Если
												прошло более 3 дней, замене подлежит только дефектная
												часть (например, камера, экран, USB-порт). Бесплатный
												ремонт предоставляется в течение 100 дней с момента
												покупки. После истечения этого срока гарантия и
												бесплатное обслуживание прекращаются. В таких случаях
												покупатель может обратиться в платный сервис.
											</p>
											<p>
												<b>6.</b> Для получения гарантийного обслуживания
												необходимо оставить неисправное, но соответствующее
												условиям устройство в CredoMobile. Устройство не
												ремонтируется и не заменяется сразу. Срок ремонта
												зависит от характера неисправности и сообщается
												отдельно.
											</p>
											<p>
												<b>7.</b> IMEI-коды физических SIM-карт каждого
												проданного телефона регистрируются продавцом в системе
												UZIMEI. Для телефонов без физического SIM-слота
												регистрируется только один IMEI-код. Продавец не несёт
												обязанности регистрировать IMEI-код второго eSIM-слота.
												Покупатель может самостоятельно зарегистрировать его
												через платные сервисы.
											</p>
										</div>
									)}

									{isTablet && (
										<div>
											<p>
												<b>2.</b> Устройство не должно быть вскрыто. Это легко
												проверить — каждое устройство имеет пломбы,
												свидетельствующие о том, что оно не открывалось.
											</p>
											<div>
												<p>
													<b>3.</b> В случае наличия внешних повреждений
													устройство не подлежит гарантийному обслуживанию.
													Например, если на углу экрана планшета есть трещина
													или вмятина, даже если, скажем, камера работает
													неисправно, CredoMobile откажет в гарантийном
													обслуживании. Причина проста — трещина на экране
													означает, что планшет был уронен или ударен,
													следовательно, и камера могла повредиться при этом.
													Производитель не несёт ответственности в таких
													случаях.
												</p>
											</div>
											<p>
												<b>4.</b> В программное обеспечение устройства не должны
												быть внесены нелегальные изменения. Если, например,
												планшету был предоставлен root-доступ, производитель
												имеет право отказать в обслуживании. Подобные изменения
												могут привести к сбоям в работе отдельных компонентов
												или системы в целом. CredoMobile не несёт
												ответственности за такие случаи. Устройства с
												установленными бета-версиями операционных систем также
												не подлежат гарантийному обслуживанию.
											</p>
											<p>
												<b>5.</b> В случае выявления заводского дефекта в
												течение 3 дней после покупки (без вины покупателя),
												устройство будет заменено на аналогичное. Если
												устройство предоставляется спустя более 3 дней после
												покупки, замене подлежит только дефектный компонент
												(камера, экран, USB-порт и др.), а не само устройство.
												Бесплатный ремонт действует в течение 100 дней после
												покупки. По истечении этого срока CredoMobile не
												предоставляет ни гарантийного, ни бесплатного сервисного
												обслуживания. В этом случае покупатель вправе обратиться
												в платные сервисные центры.
											</p>
											<p>
												<b>6.</b> Для получения гарантийного обслуживания
												устройство, соответствующее вышеуказанным условиям,
												необходимо оставить в CredoMobile. Устройство не
												подлежит немедленному ремонту или замене детали. Срок
												определяется в зависимости от характера неисправности.
											</p>
											<p>
												<b>7.</b> IMEI-коды слотов для физических SIM-карт
												каждого проданного планшета регистрируются продавцом в
												системе UZIMEI. Если планшет не имеет физического слота,
												регистрируется только один IMEI-код. Продавец не обязан
												регистрировать IMEI второго eSIM-слота. Покупатель
												вправе зарегистрировать его самостоятельно через платные
												сервисы.
											</p>
										</div>
									)}

									{isNoutbuk && (
										<div>
											<p>
												<b>2.</b> Устройство не должно быть вскрыто. Это легко
												определить — каждое устройство снабжено пломбами,
												подтверждающими, что оно не открывалось.
											</p>
											<div>
												<p>
													<b>3.</b> В случае наличия внешних повреждений
													устройство не подлежит гарантийному обслуживанию.
													Например, если на корпусе устройства имеется трещина
													или вмятина, даже при неисправности другой части
													(например, камеры), CredoMobile не оказывает
													гарантийное обслуживание. Причина очевидна —
													повреждение корпуса свидетельствует о падении или
													ударе, а камера могла быть повреждена в результате
													этого. Производитель не несёт ответственность за
													подобные случаи.
												</p>
											</div>
											<p>
												<b>4.</b> В программное обеспечение устройства не должно
												быть внесено нелегальных изменений. Например, взлом
												активации Windows или BIOS-паролей может стать
												основанием для отказа в гарантийном обслуживании. Такие
												вмешательства могут привести к сбоям в работе
												компонентов или системы, и CredoMobile не несёт
												ответственности за такие случаи. Гарантия также не
												распространяется на устройства с установленными
												бета-версиями ОС.
											</p>
											<p>
												<b>5.</b> В случае обнаружения технического дефекта (не
												по вине покупателя) в течение 3 дней с момента покупки,
												устройство будет заменено на аналогичное. Если дефект
												обнаружен позже, чем через 3 дня, заменяется только
												неисправная часть (например, камера, экран, USB-порт и
												др.), но не само устройство. Бесплатное обслуживание
												предоставляется в течение 12 месяцев с даты покупки.
												После истечения этого срока CredoMobile не предоставляет
												ни гарантий, ни бесплатного сервиса. Покупатель вправе
												обращаться в платные сервисные центры.
											</p>
											<p>
												<b>6.</b> Для получения гарантийного обслуживания
												неисправное, но соответствующее требованиям устройство
												необходимо оставить в CredoMobile. Устройство не
												подлежит моментальному ремонту или замене детали — срок
												определяется в зависимости от характера неисправности и
												сообщается отдельно.
											</p>
										</div>
									)}

									{isTechnique && (
										<div>
											<p>
												<b>2.</b> Устройство не должно быть вскрыто. Это легко
												определить — каждая единица техники снабжена пломбой,
												подтверждающей, что устройство не открывалось.
											</p>
											<div>
												<p>
													<b>3.</b> В случае наличия внешних повреждений техника
													не подлежит гарантийному обслуживанию. Например, если
													на корпусе есть трещина или вмятина, даже при
													неисправности другой части — экрана или другой функции
													— CredoMobile не окажет гарантийное обслуживание.
													Причина проста: повреждение корпуса указывает на
													падение или удар устройства, и другие его части могли
													быть повреждены в результате этого. Производитель не
													несёт ответственности за подобные случаи.
												</p>
											</div>
											<p>
												<b>4.</b> Если в течение 3 дней с момента покупки в
												устройстве обнаружен технический дефект (не по вине
												покупателя), устройство будет заменено на аналогичное.
												Если устройство передано с дефектом позже 3 дней, замене
												подлежит только неисправная деталь. Бесплатный ремонт
												предоставляется в течение 30 дней с даты покупки. По
												истечении этого срока CredoMobile не несёт обязательств
												по гарантии и бесплатному обслуживанию. В этом случае
												покупатель вправе обратиться в платный сервис.
											</p>
											<p>
												<b>5.</b> Для получения гарантийного обслуживания
												неисправную, но соответствующую требованиям технику
												необходимо оставить в CredoMobile. Устройство не
												подлежит моментальному ремонту или замене детали — срок
												определяется в зависимости от характера неисправности и
												сообщается отдельно.
											</p>
										</div>
									)}

									<div className="mt-10">
										<p className="font-bold">
											Я полностью ознакомился(лась) с условиями гарантии и
											соглашаюсь на покупку на основании этих условий.
											__________(подпись)
										</p>
									</div>
									<div className="flex w-full mt-12 font-bold">
										<hr className="w-full border-t font-bold border-black" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</Spin>
			</DownloadStyle>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
		</Layout>
	)
}

export default DownloadRu
